export default __webpack_public_path__ + "static/media/10.be1986fb.png";